import type { CellState } from '../../../util/answerRecapMatrix';

// Theme tokens rather than hex, so the cells and the legend share the dialogs' colour system.
export const cellColor: Record<CellState, string> = {
  correct: 'green-lighten-2',
  wrong: 'highlighterred-lighten-1',
  none: 'surface-container-high',
};
